import { render } from "./PhoneListComponent.vue?vue&type=template&id=7df3393b&scoped=true"
import script from "./PhoneListComponent.vue?vue&type=script&lang=js"
export * from "./PhoneListComponent.vue?vue&type=script&lang=js"

import "./PhoneListComponent.vue?vue&type=style&index=0&id=7df3393b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df3393b"]])

export default __exports__